// SafeHtml.js
import React from "react";
import DOMPurify from "dompurify";

const SafeHtml = ({ html, tag = "div", style = {}, className = "" }) => {
  const sanitizedHtml = DOMPurify.sanitize(html);

  const Tag = tag;

  return <Tag className={className} style={style} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtml;
